import styled from "styled-components";

export const Modal1Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1024;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.color1}2f;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  opacity: 0;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: visibility 0.5s, opacity 0.5s linear;
`;
export const Modal1Content = styled.div`
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  width: 300px;
  @media only screen and (min-width: 576px) {
    /* width: max-content; */
    transform: translate(40px, 0px); //for side navbar
  }
  overflow: hidden;
  box-shadow: 0px 0px 8px 4px rgba(92, 91, 91, 0.2); /* h-offset, v-offset, blur, spread, color */
`;
export const Modal1HeaderWrapper = styled.div`
  padding: 5px 20px;
  display: flex;
  font-weight: bold;
  color: ${({ theme }) => theme.color3};
  font-size: 2.3ch;
  align-items: center;
  background-color: ${({ theme, success }) =>
    success ? theme.color2 : theme.color1};
  min-height: 60px;
  justify-content: space-between;
  i {
    font-size: 2ch;
    cursor: pointer;
    color: ${({ theme }) => theme.color3};
  }
`;
export const Modal1BodyWrapper = styled.div`
  padding: 20px;
  color: ${({ theme }) => "black"};
`;
